import { render } from "./loader.vue?vue&type=template&id=3a3370c7&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import "./loader.vue?vue&type=style&index=0&id=3a3370c7&scoped=true&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3370c7"]])

export default __exports__